import script from "./WarningLetterDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./WarningLetterDetail.vue?vue&type=script&setup=true&lang=js"

import "./WarningLetterDetail.vue?vue&type=style&index=0&id=41347547&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41347547"]])

export default __exports__